(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smo-before-you-buy"] && !Shopify.designMode) return;
  try {
    if (!window.smoBeforeBuyChatBound) {
    window.smoBeforeBuyChatBound = true;
    document.addEventListener('click', async function(event) {
      const button = event.target.closest('[data-smo-open-chat]');
      if (!button || button.getAttribute('aria-busy') === 'true') return;
      const status = button.closest('[data-smo-before-buy]').querySelector('[role="status"]');
      status.hidden = true;
      button.setAttribute('aria-busy', 'true');
      try {
        const chat = document.querySelector('shopify-chat');
        if (!chat) throw new Error('Chat unavailable');
        await Promise.race([
          customElements.whenDefined('shopify-chat'),
          new Promise((_, reject) => setTimeout(() => reject(new Error('Chat unavailable')), 5000))
        ]);
        chat.setAttribute('open', '');
      } catch (_) {
        status.hidden = false;
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
